import { connect } from 'react-redux';
import { getIsSectionFolded } from '../../redux/selectors';
import { updateNetworkBarSection } from '../../redux/actions';
var mapStateToProps = function (state, _a) {
    var sectionType = _a.sectionType;
    return ({
        isFolded: getIsSectionFolded(state, sectionType),
    });
};
var mapDispatchToProps = {
    onFoldToggle: updateNetworkBarSection,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=FoldableGroupList.container.js.map